//====================================================
//  Function: Payment btn
//====================================================
function componentPaymentBtn() {
  if ($('.js-payment-btn').length) {
    const googlePayItem = document.getElementById('google-pay')
    const googlePayBtn = googlePayClient.createButton({
      buttonColor: 'default',
      buttonType: 'pay',
      buttonLocale: 'en',
      onClick: () => {},
    })

    googlePayItem.appendChild(googlePayBtn)
  }
}
